package com.parmartechnologies.core.feature.auth.model

import com.parmartechnologies.core.feature.business.model.Business

class BusinessConstants {
    var business: Business? = null
    val theme = """
        {
  "PrimaryColor": "0xFFBB86FC",
  }
    """.trimIndent()

    val selectedBusiness = ""
//    val selectedBusiness = """
//        {
//  "_id": "6364c00fb25244fcf46425f0",
//  "business_number": 96,
//  "user_id": "6364bf91b25244fcf46425ce",
//  "business_type_id": "61aca7bb68b40d644a588611",
//  "is_deleted": false,
//  "name": "Bharat Grocery Store",
//  "address": {
//    "unique_id": 1696783095646,
//    "user_id": "6522da81a0dc5bddaf21d0d5",
//    "name": "",
//    "House": "157",
//    "FlatNumber": "",
//    "ZipCode": 110025,
//    "country": "",
//    "State": "Delhi",
//    "City": "New Delhi",
//    "Area": "Sarai Jullena",
//    "LandMark": "Near Evergreen Sweets",
//    "Floor": "",
//    "mobile_number": "",
//    "Type": "OTHER",
//    "is_primary": false,
//    "is_deleted": false,
//    "created_at":"2023-09-12T03:49:41.340Z",
//    "updated_at": "2023-09-12T03:49:41.340Z",
//    "_id":  "6522daf8a0dc5bddaf21d0da"
//  },
//  "dealer_name": "",
//  "product_types": [],
//  "gst_number": "",
//  "pan_number": "",
//  "pan_verified": "false",
//  "gst_verified": "false",
//  "BusiniessVerified": "false",
//  "email_id": "ankur@gmail.com",
//  "mobile_number": "+4917670223162",
//  "dial_code": "",
//  "gender": null,
//  "device_id": "",
//  "profile_picture": [],
//  "last_seen": "2022-11-04T05:35:12.141Z",
//  "created_at": "2022-11-04T05:35:12.141Z",
//  "updated_at": "2022-11-04T05:35:12.141Z",
//  "__v": 0
//}
//    """.trimIndent()

}